export default {
    setup: (bugout, session, hooks = {}) => {
        console.debug('network setup')
        const callbacks = {}

        const send = require('./parser')(bugout, session, callbacks, hooks)
        
        return {
            bugout,
            send,
            callbacks
        }
    }
}
